import React, { useMemo } from 'react'
import { ScrollView, Text, View } from 'react-native'
import { useSelector } from 'react-redux';
import { useCssStyle } from '../../../customHook/getCssStyle';
import { useTranslation } from 'react-i18next';
import HeaderWithBack from '../../../components/Header/headerWithBack';
import { ImageComp } from '../../../components/Image/Image';
import { getCleanUrl } from '../../../utils/Helper';
import CustomPressable from '../../../components/customPressable/customPressable';
import { ARROW_RIGHT, CHECK, CHEVRON_RIGHT, PLUS } from '../../../assets';

const VenueList = (props) => {
    const { handleNext, handleGoBack } = props;

    const getStyles = useCssStyle();
    const { t } = useTranslation();

    const { currentWidget } = useSelector(state => state.deviceConfigSlice);
    const { allVenues } = useSelector(state => state.tableReservationSlice);

    const renderHeader = () => {
        return (
            <View style={getStyles(['widgetmainContainerHeaderContainer', 'sevenRoomsVenueListHeaderContainer'])} id='sevenRoomsVenueListHeaderContainer'>
                {
                    currentWidget?.widgetHeaderImageUrl && <ImageComp source={getCleanUrl(currentWidget?.widgetHeaderImageUrl)} style={getStyles(['widgetmainContainerHeaderImg', 'sevenRoomsVenueListHeaderImg'])} id={"sevenRoomsVenueListHeaderImg"}/>
                }
                <View style={getStyles(['widgetmainContainerHeaderTitleContainer', 'sevenRoomsVenueListMainPageHeaderTitleContainer'])} id='sevenRoomsVenueListMainPageHeaderTitleContainer'>
                    <Text style={getStyles(['widgetmainContainerHeaderTitle', 'sevenRoomsVenueListHeaderTitle'])} id='sevenRoomsVenueListHeaderTitle'>{t('reservations.heading')}</Text>
                    <Text style={getStyles(['widgetmainContainerHeaderSubTitle', 'sevenRoomsVenueListHeaderSubTitle'])} id='sevenRoomsVenueListHeaderSubTitle'>{t('reservations.sub_heading')}</Text>
                </View>
            </View>
        )
    }



    return (
        <View style={getStyles(['widgetRootContainer', 'sevenRoomsVenueListRootContainer'])} id="widgetRootContainer sevenRoomsVenueListRootContainer">
            <HeaderWithBack handleCustomBackPress={handleGoBack} />

            <ScrollView
                automaticallyAdjustKeyboardInsets={true} 
                contentContainerStyle={getStyles(['widgetmainContainer', 'sevenRoomsVenueListMainContainer'])} 
                showsVerticalScrollIndicator={false}
                nestedScrollEnabled
                id='sevenRoomsVenueListMainContainer'
            >
                {renderHeader()}

                <View style={getStyles(['widgetmainContainerChildContainer', 'sevenRoomsVenueListMainContainerChildContainer'])} id='sevenRoomsVenueListMainContainerChildContainer'>
                    {allVenues?.allVenueData?.map((iterator, index) => {

                        return <CustomPressable key={index} style={getStyles(['list_itemContainer', 'sevenRoomsVenueList_itemContainer'])} id={`list_itemContainer sevenRoomsVenueList_itemContainer`} onPress={() => handleNext(iterator)}>
                            {iterator?.imageName && <ImageComp source={getCleanUrl(iterator?.imageName)} style={getStyles(["list_itemContainer_image", 'sevenRoomsVenueList_itemContainer_image'])} id="list_itemContainer_image sevenRoomsVenueList_itemContainer_image" />}


                            <View style={getStyles(['list_itemContainer_textContainer', 'sevenRoomsVenueList_itemContainer_textContainer'])} id={`list_itemContainer_textContainer sevenRoomsVenueList_itemContainer_textContainer`}>
                                {iterator?.name && <Text 
                                    style={getStyles(['list_itemContainer_textContainer_title', 'sevenRoomsVenueList_itemContainer_textContainer_title'])}
                                    id={`list_itemContainer_textContainer_title sevenRoomsVenueList_itemContainer_textContainer_title`}
                                >{iterator.name}</Text>}

                                {iterator?.description && <Text
                                    style={getStyles(['list_itemContainer_textContainer_subtitle', 'sevenRoomsVenueList_itemContainer_textContainer_subtitle'])} 
                                    id={`list_itemContainer_textContainer_subtitle sevenRoomsVenueList_itemContainer_textContainer_subtitle`}
                                    numberOfLines={2} 
                                    ellipsizeMode="tail"
                                >{iterator.description}</Text>}
                                </View>
                    
                                <View style={getStyles(['list_itemContainer_arrow', 'sevenRoomsVenueList_itemContainer_arrow'])} id={`list_itemContainer_arrow sevenRoomsVenueList_itemContainer_arrow`} >
                                    <ImageComp 
                                        source={CHEVRON_RIGHT} 
                                        style={getStyles(['list_itemContainer_arrow_img', 'sevenRoomsVenueList_itemContainer_arrow_img'])}
                                        id={`list_itemContainer_arrow_img sevenRoomsVenueList_itemContainer_arrow_img`}
                                    />
                                </View>


                        </CustomPressable>
                    })}
                    

                </View>
            </ScrollView>
        </View>
    )
}

export default VenueList
